export default __webpack_public_path__ + "static/last_year_3-a40744873fc0ffe58781f663a6366ea6.webp";